module.exports = __webpack_public_path__ + "img/Deutsche_Post.ba0ccd99.png";